// @flow
import Api, { apiTypes } from 'app/common/api';


const api: Api = new Api(apiTypes.API_GENERAL);
const axiosWHeaders = api.commonRequest.bind(api);

export default axiosWHeaders;
